module.exports = __webpack_public_path__ + "img/eliminar_outline_rojo.a5170bc3.svg";